export default {"src":"/_next/static/media/hippa.0643f69c.svg","height":445,"width":845,"blurWidth":0,"blurHeight":0};